module.exports = __webpack_public_path__ + "static/img/doc-guide-1.bae500e.png";